"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

// TUNE-12025: the adswizz listener id and global function are
// set internally by the AdsWizz SDK scripts in Mint
exports.default = function () {
  return (
    // eslint-disable-next-line no-undef
    window.com_adswizz_synchro_getListenerId && window.com_adswizz_synchro_getListenerId()
  );
};
//# sourceMappingURL=getAdswizzListenerId.js.map